export interface DeviceFrameRatio {
  readonly horizontalRatio: number;
  readonly verticalRatio: number;
}

export interface RemoteFrameSize {
  readonly deviceFrameHeight: number;
  readonly deviceFrameWidth: number;
}

export enum ScreenShareButtonTrigger {
  BACK = '1',
  HOME = '2',
  APPS = '3',
}

export enum ScreenShareSessionStatus {
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  DISCONNECTED = 'DISCONNECTED',
  RefusedByCustomer = 'REFUSED_BY_CUSTOMER',
  RECONNECTING = 'RECONNECTING',
}

export interface ScreenShareInitStatus {
  readonly message:
    | 'G_INIT_01_CLOSE_SESSION_END'
    | 'G_INIT_01_CLOSE_SESSION_START'
    | 'G_INIT_02_WAIT_SESSION_READY_TO_BE_OPEN_END'
    | 'G_INIT_02_WAIT_SESSION_READY_TO_BE_OPEN_START'
    | 'G_INIT_03_OPEN_SESSION_END'
    | 'G_INIT_03_OPEN_SESSION_START'
    | 'G_INIT_04_WAIT_DEVICE_READY_FOR_SIGNALING_END'
    | 'G_INIT_04_WAIT_DEVICE_READY_FOR_SIGNALING_START'
    | 'G_INIT_05_GET_RTC_CONFIGURATION_END'
    | 'G_INIT_05_GET_RTC_CONFIGURATION_START'
    | 'G_INIT_06_INIT_RTC_END'
    | 'G_INIT_06_INIT_RTC_START'
    | 'G_INIT_07_CONNECT_RTC_SESSION_END'
    | 'G_INIT_07_CONNECT_RTC_SESSION_START'
    | 'G_INIT_END'
    | 'G_INIT_START';
  readonly progressInPercent: number;
}

export interface ScreenShareEvent {
  readonly code:
    | 'BROWSER_ANSWER_REGISTRATION_ERROR'
    | 'BROWSER_ANSWER_REGISTRATION_START'
    | 'BROWSER_ANSWER_REGISTRATION_SUCCESS'
    | 'CLOSE_DEVICE_SESSION_ERROR'
    | 'CLOSE_DEVICE_SESSION_START'
    | 'CLOSE_DEVICE_SESSION_SUCCESS'
    | 'CONNECTION_REFUSED_BY_CUSTOMER'
    | 'CREATE_DEVICE_OFFER_ERROR'
    | 'CREATE_DEVICE_OFFER_START'
    | 'CREATE_DEVICE_OFFER_SUCCESS'
    | 'DEVICE_ICE_CANDIDATE_MALFORMED'
    | 'DEVICE_ICE_CANDIDATE_UN_PARSABLE'
    | 'DEVICE_OFFER_REGISTRATION_ERROR'
    | 'DEVICE_OFFER_REGISTRATION_START'
    | 'DEVICE_OFFER_REGISTRATION_SUCCESS'
    | 'G_INIT_01_CLOSE_SESSION_END'
    | 'G_INIT_01_CLOSE_SESSION_START'
    | 'G_INIT_02_WAIT_SESSION_READY_TO_BE_OPEN_END'
    | 'G_INIT_02_WAIT_SESSION_READY_TO_BE_OPEN_START'
    | 'G_INIT_03_OPEN_SESSION_END'
    | 'G_INIT_03_OPEN_SESSION_START'
    | 'G_INIT_04_WAIT_DEVICE_READY_FOR_SIGNALING_END'
    | 'G_INIT_04_WAIT_DEVICE_READY_FOR_SIGNALING_START'
    | 'G_INIT_05_GET_RTC_CONFIGURATION_END'
    | 'G_INIT_05_GET_RTC_CONFIGURATION_START'
    | 'G_INIT_06_INIT_RTC_END'
    | 'G_INIT_06_INIT_RTC_START'
    | 'G_INIT_07_CONNECT_RTC_SESSION_END'
    | 'G_INIT_07_CONNECT_RTC_SESSION_START'
    | 'G_INIT_END'
    | 'G_INIT_START'
    | 'GET_ALL_BROWSER_ICE_CANDIDATE_START'
    | 'GET_ALL_BROWSER_ICE_CANDIDATE_SUCCESS'
    | 'GET_CONFIGURATION_ERROR_NOT_ALLOWED_BY_USER'
    | 'GET_CONFIGURATION_ERROR'
    | 'GET_CONFIGURATION_START'
    | 'GET_CONFIGURATION_SUCCESS'
    | 'GET_DEVICE_ANSWER_ERROR_TIMEOUT'
    | 'GET_DEVICE_ANSWER_ERROR'
    | 'GET_DEVICE_ANSWER_START'
    | 'GET_DEVICE_ANSWER_SUCCESS'
    | 'GET_DEVICE_FRAME_RESOLUTION_START'
    | 'GET_DEVICE_FRAME_RESOLUTION_SUCCESS'
    | 'GET_DEVICE_ICE_CANDIDATE_ERROR_TIMEOUT'
    | 'GET_DEVICE_ICE_CANDIDATE_ERROR'
    | 'GET_DEVICE_ICE_CANDIDATE_START'
    | 'GET_DEVICE_ICE_CANDIDATE_SUCCESS'
    | 'GET_DEVICE_OFFER_ERROR_TIMEOUT'
    | 'GET_DEVICE_OFFER_ERROR'
    | 'GET_DEVICE_OFFER_START'
    | 'GET_DEVICE_OFFER_SUCCESS'
    | 'GET_REMOTE_STREAM_START'
    | 'GET_REMOTE_STREAM_SUCCESS'
    | 'GET_REMOTE_STREAM_TRACK'
    | 'INITIATE_RTC_PEER_START'
    | 'INITIATE_RTC_PEER_SUCCESS_AND_CONNECTED'
    | 'INITIATE_RTC_PEER_SUCCESS'
    | 'OPEN_SESSION_ERROR'
    | 'OPEN_SESSION_START'
    | 'OPEN_SESSION_SUCCESS'
    | 'PARSE_DEVICE_ANSWER'
    | 'PARSE_DEVICE_OFFER'
    | 'READY_FOR_STATUS_TIMEOUT'
    | 'READY_FOR_STATUS'
    | 'RTC_CONNECTION_ERROR'
    | 'RTC_DATA_CHANNEL_MESSAGE'
    | 'SCREEN_SHARE_SESSION_REFUSED_BY_USER'
    | 'SCREEN_SHARE_SESSION_TIMEOUT'
    | 'SEND_ANSWER_ERROR'
    | 'SEND_ANSWER_START'
    | 'SEND_ANSWER_SUCCESS'
    | 'SEND_BROWSER_ICE_CANDIDATE_ERROR'
    | 'SEND_BROWSER_ICE_CANDIDATE_START'
    | 'SEND_BROWSER_ICE_CANDIDATE_SUCCESS'
    | 'SETUP_REMOTE_DESKTOP_CANVAS_RX_START'
    | 'SETUP_REMOTE_DESKTOP_CANVAS_RX_SUCCESS'
    | 'START_CAPTURE_GESTURE'
    | 'STOP_RTC_SIGNAL_TRIGGER'
    | 'UNEXPECTED_MESSAGE_FROM_DEVICE'
    | 'WAIT_FOR_READY_STATUS_STATUS_ERROR'
    | 'WAIT_FOR_READY_STATUS_STATUS';
  readonly payload?: unknown;
  readonly type: 'ERROR' | 'INFO' | 'RESET';
}
